import _ from 'lodash';

export default function (value) {
  if (_.isString(value)) {
    value = parseFloat(value);
  }
  if (!_.isNumber(value)) {
    return '--%';
  }
  const percent = (100 * value).toFixed(2);
  return `${percent}%`;
}
